import React from "react";
import { DashboardActionplanCard } from "./_components/DashboardActionplanCard";
import { DashboardAnnualMeetingCard } from "./_components/DashboardAnnualMeetingCard";
import { DashboardArticleCard } from "./_components/DashboardArticleCard";
import { DashboardMeetingCard } from "./_components/DashboardMeetingCard";
import { DashboardSafetyInspectionCard } from "./_components/DashboardSafetyInspectionCard";
import { DashboardWorkplaceAssessmentCard } from "./_components/DashboardWorkplaceAssessmentCard";

import { ProtectedPageContext } from "../_contexts/ProtectedPageContext";
import { UserToken } from "../../amorg-common";
import { Grid } from "../../designSystem/compositeComponents/FlexHelpers";

export default function DashboardComponents(): JSX.Element {

    const context = React.useContext(ProtectedPageContext);
    const activeUser: UserToken | null = context?.user ?? null;

    const showActionPlan = activeUser?.features.includes('ActionPlans');
    const showWorkplaceAssessment = activeUser?.features.includes('WorkplaceAssessment');
    const showAnnualStatus = activeUser?.features.includes('AnnualStatus');
    const showSafetyInspection = activeUser?.features.includes('SafetyInspection');
    const showMeeting = activeUser?.features.includes('Meeting');
    const showArticle = activeUser?.features.includes('Articles');


    return (
        
        <Grid gridTemplateColumns={3} gap={24}>

            {showActionPlan && 
                <DashboardActionplanCard />
            }
            {showWorkplaceAssessment && 
                <DashboardWorkplaceAssessmentCard />
            }
            {showAnnualStatus && 
                <DashboardAnnualMeetingCard /> 
            }
            {showSafetyInspection && 
                <DashboardSafetyInspectionCard />
            }
            {showMeeting && 
                <DashboardMeetingCard />
            }
            {showArticle && 
                <DashboardArticleCard />
            }

        </Grid>
        
    );
}


